import type { ChangeEvent } from 'react';
import type { SelectProps } from './select.type';
import { motion } from 'motion/react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { getNextIndex, isNumberInRange } from '@/components/calendar/utils';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/calendar/components/select/select-v1.css';
import '@/components/calendar/components/select/select-v2.css';

export default function Select(props: SelectProps) {
  const { name, value, options, onChange } = props;
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);

  const chevronSize = cssVersion === 1 ? 20 : 24;

  return (
    <div data-css-version={cssVersion} className='calendar-select'>
      <motion.button
        type='button'
        className='calendar-select__arrow'
        whileTap={{ scale: 1.125 }}
        onClick={() =>
          onChange(getNextIndex(options, isNumberInRange([0, options.length], value) ? value : 0, 'backward'))
        }
      >
        <ChevronLeft strokeWidth={2} width={chevronSize} height={chevronSize} />
      </motion.button>
      <select
        name={name}
        value={isNumberInRange([0, options.length], value) ? value : 0}
        className='calendar-select__element'
        onChange={(e: ChangeEvent<HTMLSelectElement>) => onChange(Number(e.target.value))}
      >
        {options.map((option, optionIndex) => (
          <option key={option} value={optionIndex}>
            {option}
          </option>
        ))}
      </select>
      <motion.button
        type='button'
        className='calendar-select__arrow'
        whileTap={{ scale: 1.125 }}
        onClick={() =>
          onChange(getNextIndex(options, isNumberInRange([0, options.length], value) ? value : 0, 'forward'))
        }
      >
        <ChevronRight strokeWidth={2} width={chevronSize} height={chevronSize} />
      </motion.button>
    </div>
  );
}
